var COTUIComponentType;
(function (COTUIComponentType) {
    COTUIComponentType[COTUIComponentType["HorizontalSplit"] = 0] = "HorizontalSplit";
    COTUIComponentType[COTUIComponentType["VerticalSplit"] = 1] = "VerticalSplit";
})(COTUIComponentType || (COTUIComponentType = {}));
//# sourceMappingURL=odGraphConcept.js.map